const buildingCategories = [
    {
      id: '1',
      name: 'Tools and Equipment',
      description: 'Hand tools, power tools, and equipment for construction and renovation.',
    },
    {
      id: '2',
      name: 'Building Materials',
      description: 'Materials like lumber, bricks, cement, and roofing supplies.',
    },
    {
      id: '3',
      name: 'Home Appliances',
      description: 'Appliances for homes, including HVAC systems, water heaters, and more.',
    },
    {
      id: '4',
      name: 'Furniture and Fixtures',
      description: 'Indoor and outdoor furniture, lighting, and decorative fixtures.',
    },
    {
      id: '5',
      name: 'Safety Gear and Supplies',
      description: 'Safety equipment such as helmets, gloves, vests, and safety signs.',
    },
    {
      id: '6',
      name: 'Vehicles and Machinery',
      description: 'Construction vehicles, heavy machinery, and related equipment.',
    },
    {
      id: '7',
      name: 'Electrical and Plumbing',
      description: 'Electrical components, plumbing fixtures, and supplies.',
    },
    {
      id: '8',
      name: 'Land and Properties',
      description: 'Land for sale or rent, commercial and residential properties.',
    },
    {
      id: '9',
      name: 'Design and Architecture',
      description: 'Architectural services, blueprints, and design consultations.',
    },
    {
      id: '10',
      name: 'Home Decor and Renovation',
      description: 'Interior design, renovation services, and decor items.',
    },
    {
      id: '11',
      name: 'Consultation and Services',
      description: 'Contractors, builders, plumbers, electricians, and related services.',
    },
    {
      id: '12',
      name: 'Landscaping and Outdoor',
      description: 'Landscaping services, outdoor furniture, and garden equipment.',
    },
    {
      id: '13',
      name: 'Storage and Organization',
      description: 'Storage solutions, shelving, and organization products.',
    },
    {
      id: '14',
      name: 'Environmental Solutions',
      description: 'Green and sustainable building products and solutions.',
    },
  ];
  
  export default buildingCategories;
  